/**
 * Mock API Dev Tools Component
 * 
 * A React component that shows mock API status and endpoint coverage
 * in the browser console. Can be used during development to verify
 * that all services are properly wired.
 */

import { useEffect } from 'react'
import { verifyMockApiEnabled, logMockApiEndpoints } from './mockApiVerification'

/**
 * Component that logs mock API status to console on mount
 * Use this in your App.tsx or Layout component during development
 */
export function MockApiDevTools() {
  useEffect(() => {
    // Only run in development
    if (import.meta.env.DEV) {
      const isEnabled = verifyMockApiEnabled()
      
      if (isEnabled) {
        // Log endpoints after a short delay to ensure console is ready
        setTimeout(() => {
          logMockApiEndpoints()
        }, 500)
        
        // Log helpful tips
        console.log(
          '%c[Mock API] Development Tips:',
          'color: #3b82f6; font-weight: bold; font-size: 12px;'
        )
        console.log(
          '%c• All API requests are handled locally\n• Data persists only in browser session\n• Check Network tab - requests show "[API] Using mock API"\n• Mock data is defined in src/mocks/mockApi.ts',
          'color: #64748b; font-size: 11px; line-height: 1.6;'
        )
      }
    }
  }, [])
  
  // This component doesn't render anything
  return null
}
